// FunnelChart — embudo vertical con barras horizontales decrecientes
import Chart from "react-apexcharts";
import { formatNum } from "../../lib/constants";

export default function FunnelChart({ data, height = 420 }) {
  const categories = data.map((d) => d.ambito);
  const series = [{ name: "Pacientes", data: data.map((d) => d.pacientes) }];
  const colors = data.map((d) => d.color || "#7C3AED");

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Inter, sans-serif",
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: true,
        barHeight: "70%",
        distributed: true,
        dataLabels: { position: "center" },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opt) => {
        const d = data[opt.dataPointIndex];
        return `${formatNum(val)}  ·  ${d.pct_entrada?.toFixed(1)}%`;
      },
      style: { fontSize: "12px", fontWeight: 600, colors: ["#fff"] },
      dropShadow: { enabled: true, blur: 2, opacity: 0.4 },
    },
    colors,
    xaxis: {
      categories,
      labels: {
        formatter: (v) => formatNum(v),
        style: { fontSize: "11px", colors: "#64748B" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { style: { fontSize: "12px", colors: "#334155", fontWeight: 500 } },
    },
    grid: { borderColor: "#E2E8F0", strokeDashArray: 3, padding: { left: 10 } },
    legend: { show: false },
    tooltip: {
      custom: ({ dataPointIndex }) => {
        const d = data[dataPointIndex];
        return `<div style="padding:10px 14px;font-family:Inter,sans-serif">
          <div style="font-weight:700;color:#0f172a;margin-bottom:4px">${d.ambito}</div>
          <div style="font-size:12px;color:#475569"><b>${formatNum(d.pacientes)}</b> pacientes</div>
          <div style="font-size:11px;color:#64748b">Del total: ${d.pct_entrada?.toFixed(1)}%</div>
          <div style="font-size:11px;color:#64748b">Vs anterior: ${d.pct_anterior?.toFixed(1)}%</div>
        </div>`;
      },
    },
  };

  return <Chart options={options} series={series} type="bar" height={height} />;
}
